// Online reef stores in Near You (owner, 2026-09-28): a separate list,
// no map pin, filtered by where they ship. Pure, shared by the server and
// /app.

export const SHIP_REGIONS = [
  { k: 'US', label: 'United States' },
  { k: 'CA', label: 'Canada' },
  { k: 'UK', label: 'United Kingdom' },
  { k: 'EU', label: 'European Union' },
  { k: 'AU', label: 'Australia' },
  { k: 'NZ', label: 'New Zealand' },
  { k: 'WORLD', label: 'Worldwide' },
];

const EU = new Set(
  'AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE'.split(' ')
);

// A country code (Cloudflare's CF-IPCountry) to a shipping region, or null.
export function regionForCountry(cc) {
  const c = String(cc || '').toUpperCase();
  if (c === 'GB') return 'UK';
  if (EU.has(c)) return 'EU';
  return ['US', 'CA', 'AU', 'NZ'].includes(c) ? c : null;
}

export function sanitizeShipsTo(input) {
  const list = Array.isArray(input)
    ? input
    : String(input || '')
        .split(/[,\s]+/)
        .filter(Boolean);
  const known = new Set(SHIP_REGIONS.map((r) => r.k));
  const alias = (x) => (x === 'GB' ? 'UK' : x);
  return [...new Set(list.map((x) => alias(String(x).toUpperCase())).filter((x) => known.has(x)))];
}

export function shipsToRegion(store, region) {
  const list = Array.isArray(store?.ships_to) ? store.ships_to : [];
  if (list.includes('WORLD')) return true;
  return !!region && list.includes(region);
}
